export const dataprojects = {
	Avantte: {
		name: 'Avantte',
		book: {
			corporateName: 'BIABO PERU S.A.',
			ruc: '20503925461',
			partida: '11351046',
			address: 'CAL.MONTE ROSA NRO. 270 INT. 1004 (ALT. CDRA 4 DE AV. PRIMAVERA) LIMA - LIMA - SANTIAGO DE SURCO',
		},
	},
	Garden: {
		name: 'Garden',
		book: {
			corporateName: 'BIABO PERU S.A.',
			ruc: '20503925461',
			partida: '11351046',
			address: 'CAL.MONTE ROSA NRO. 270 INT. 1004 (ALT. CDRA 4 DE AV. PRIMAVERA) LIMA - LIMA - SANTIAGO DE SURCO',
		},
	},
	Skyna: {
		name: 'Skyna',
		book: {
			corporateName: 'BIABO PERU S.A.',
			ruc: '20503925461',
			partida: '11351046',
			address: 'CAL.MONTE ROSA NRO. 270 INT. 1004 (ALT. CDRA 4 DE AV. PRIMAVERA) LIMA - LIMA - SANTIAGO DE SURCO',
		},
	},
};
